// noinspection ES6UnusedImports
import React, {useEffect} from 'react';
import CookieHelper from '@core/scripts/helper/cookie';

const COOKIE_NAME = 'viewedDigistyles';
const COOKIE_LIFETIME = 365;
const MAX_STORAGE_SIZE = 16;

export default function LastSeenStorage({personalOptIn, digistyleId}) {
    useEffect(() => {
        const expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + COOKIE_LIFETIME);
        if (personalOptIn !== 'true' || !digistyleId) {
            return;
        }
        const existingCookie = CookieHelper.get(COOKIE_NAME);
        if (existingCookie) {
            const existingArticles = existingCookie.split(',');
            while (existingArticles.length >= MAX_STORAGE_SIZE) {
                existingArticles.pop();
            }
            if (!existingArticles.includes(digistyleId)) {
                existingArticles.unshift(digistyleId);
            } else {
                const indexToMove = existingArticles.indexOf(digistyleId);
                if (indexToMove !== -1) {
                    const movedArticle = existingArticles.splice(indexToMove, 1)[0];
                    existingArticles.unshift(movedArticle);
                }
            }
            CookieHelper.set(COOKIE_NAME, existingArticles.join(','), {expires: expirationDate});
        } else {
            CookieHelper.set(COOKIE_NAME, digistyleId, {expires: expirationDate});
        }
    }, []);
}
